import { render, staticRenderFns } from "./op-purchase-order-product.vue?vue&type=template&id=edd466f6&scoped=true&"
import script from "./op-purchase-order-product.vue?vue&type=script&lang=js&"
export * from "./op-purchase-order-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd466f6",
  null
  
)

export default component.exports